export const LOGO_SMALL = "/euvision_logo_turisz.small.jpg";

export const ANONYMOUS_NAME = "Anonymous";
export const IPAPI_URL = "https://ipapi.co/json/";

export const PASSWORD_VALIDATION_REGEXP = "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$";
